import { useMutation } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { AssociateDocumentPayload, AssociateDocumentResponse } from '../types';
import issuesApi from '../api/issues.api';
import { DefaultErrorMessage } from '../displayStrings';

type UseAssociateDocumentType = {
  associateDocumentMutate: ({ eventId, stepId, ownerId }: AssociateDocumentPayload) => void;
  isAssociateDocumentLoading: boolean;
};

export const useAssociateDocument = (
  onSuccess: (data: AssociateDocumentResponse | undefined, payload: AssociateDocumentPayload) => void,
): UseAssociateDocumentType => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();

  const { mutate: associateDocumentMutate, isLoading: isAssociateDocumentLoading } = useMutation(
    ({ eventId, stepId, ownerId }: AssociateDocumentPayload) =>
      issuesApi.associateDocument(companyId, eventId, stepId, ownerId),
    {
      onSuccess: (data, payload) => {
        onSuccess(data, payload);
      },
      onError: () => {
        showToast({
          description: DefaultErrorMessage,
          status: 'error',
        });
      },
    },
  );

  return { associateDocumentMutate, isAssociateDocumentLoading };
};
